export enum UserRole {
  EventHost = "wveventhost",
  Affiliate = "gpxpro",
  Admin = "wvadmin",
}

export enum PackageSubscriptionStatus {
  Active = "Active",
  Cancelled = "Cancelled",
  Expired = "Expired",
  Suspended = "Suspended",
}

export enum PackageSubscriptionBillingPeriod {
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Yearly = "Yearly",
}

export interface IPackageSubscriptionResponse {
  packageSubscriptionID?: string
  wooSubscriptionID?: string
  packageTierName?: string
  packageSubscriptionStatus?: PackageSubscriptionStatus
  billingPeriod?: PackageSubscriptionBillingPeriod
  eventsUsed?: number
  maxEvents?: number
  expiryDate?: Date
  token?: string
  oneTimePayment?: boolean
}

export interface IPackageSubscription {
  packageSubscriptionId?: string
  wooSubscriptionId?: string
  tierName?: string
  status?: PackageSubscriptionStatus
  billingPeriod?: PackageSubscriptionBillingPeriod
  eventsUsed?: number
  maxEvents?: number
  expiryDate?: Date
  token?: string

  /** Indicates whether the host's subscription tier is a one-time payment product (as opposed to a recurring subscription). */
  oneTimePayment?: boolean
}

export interface IUserResponse {
  UserID?: number
  Name?: string
  Email?: string
  AffiliateID?: string
  Roles?: UserRole[]
  EmailConfirmed?: boolean
}

export interface IUserResponseV1 {
  name?: string
  email?: string
  affiliateId?: string
  roles?: UserRole[]
  packageSubscriptionDTO?: IPackageSubscriptionResponse
  emailConfirmed?: boolean
}

export interface IUserForm {
  name?: string
  email?: string
  current_password?: string
  new_password?: string
  confirm_new_password?: string
}
